// extracted by mini-css-extract-plugin
module.exports = {"root":"Skeleton_root__3qp1L","skeleton":"Skeleton_skeleton__LNbe5","btns":"Skeleton_btns__1xco4"};